import React, { useRef, useState } from 'react';

import { useRecoilValue } from 'recoil';

import { currentPractice } from 'components/practice/practiceState';
import { getProceduresTotal } from 'components/public/lib/utils';
import Popover from 'components/shared/Popovers/Popover/Popover';

import { getInvoicesFromSelectedRows } from '../lib/utils';

import { InvoiceModal } from './InvoiceModal';
import InvoicePrintView from './InvoicePrintView';
import NewInvoice from './NewInvoice';
import NewInvoiceView from './NewInvoiceView';

const InternalInvoicesNavigatePopover = ({ data }) => {
  let finalGroupInvoices = [];
  if (data) {
    finalGroupInvoices = getInvoicesFromSelectedRows([data]);
  }

  const pageToPrintRef = useRef();

  const practice = useRecoilValue(currentPractice);

  const claims = practice?.display_settings?.claims;

  const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
  const { patient_id, appointment_id, eraIds = [] } = data || {};

  const onPreview = () => {
    setInvoiceModalVisible(true);
  };

  const handleInvoiceModalClose = () => {
    setInvoiceModalVisible(false);
  };

  const modalContent = (
    <>
      {finalGroupInvoices.map((finalInvoice, idx) => {
        const invoiceDetails = getProceduresTotal([finalInvoice]);
        return (
          <div key={idx}>
            <InvoicePrintView
              patient={finalInvoice?.patient}
              practice={practice}
              createdAt={finalInvoice?.dateofservice}
              content={
                <NewInvoice invoice={finalInvoice} isView>
                  <NewInvoiceView hasClaims={claims} invoiceDetails={invoiceDetails} />
                </NewInvoice>
              }
            />
          </div>
        );
      })}
    </>
  );

  if (!data) return null;

  const options = [
    { label: 'Preview Invoice', onClick: onPreview, icon: 'eye-mono' },
    {
      label: 'View Patient',
      onClick: () => window.open(`/portal/charts/${patient_id}/billing/invoices`, '_blank'),
      icon: 'user-2-mono'
    },
    appointment_id && {
      label: 'View Appointment',
      onClick: () => window.open(`/portal/appointments?appointment_id=${appointment_id}`, '_blank'),
      icon: 'calendar-tick-mono'
    },
    eraIds?.length > 0 && {
      label: 'View Era',
      icon: 'wallet-mono',
      children: eraIds.map((eraId) => ({
        label: eraId,
        onClick: () => window.open(`/portal/beyond-billing/era/${eraId}`, '_blank')
      }))
    }
  ].filter(Boolean);

  return (
    <>
      <Popover
        className="flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        options={options}
        isBorder={false}
      />

      {invoiceModalVisible ? (
        <InvoiceModal
          // prevButton={prevButton}
          title="Preview Invoice"
          invoiceModalVisible={invoiceModalVisible}
          onClose={handleInvoiceModalClose}
          modalContent={
            <div ref={pageToPrintRef} className="h-full w-auto">
              {modalContent}
            </div>
          }
        />
      ) : null}
    </>
  );
};

export default InternalInvoicesNavigatePopover;
